import { render, staticRenderFns } from "./salePrompt.vue?vue&type=template&id=72ebb02e&scoped=true&"
import script from "./salePrompt.vue?vue&type=script&lang=js&"
export * from "./salePrompt.vue?vue&type=script&lang=js&"
import style0 from "./salePrompt.vue?vue&type=style&index=0&id=72ebb02e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ebb02e",
  null
  
)

export default component.exports